import api from "./api";

const SERVICE_ROOT = "notification-manager";

export const getAblyToken = () => {
  return api.get(`${SERVICE_ROOT}/notification/auth`);
};
